import { ChangeHistoryRow } from "../types";

export const ChangedByCell = ({ row }: { row: ChangeHistoryRow }) => {
  if (row.changedBy === "scheduled change") {
    return (
      <div
        style={{
          display: "inline-block",
          padding: "4px 8px",
          backgroundColor: "rgba(0, 104, 120, 0.10)",
          borderRadius: "4px",
          fontSize: "12px",
          lineHeight: "16px",
          fontWeight: 600,
          color: "#006878",
          letterSpacing: "0.5px",
        }}>
        SCHEDULED
      </div>
    );
  }

  return (
    <div
      title={row.changedBy}
      style={{
        maxWidth: 180,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}>
      {row.changedBy}
    </div>
  );
};
